/* eslint-disable prefer-destructuring */
// noinspection JSVoidFunctionReturnValueUsed

import * as MutationTypes from '@dynameat/views/reporting/mutationTypes';
import { sentryLogException } from '@core/helpers/sentryLogger';
import {
  AverageDinerTimeCalculator,
  AverageTicketCalculator,
  DinerMarginCalculator,
  DinerRevenueCalculator,
  MarginCalculator,
  OccupationCalculator,
  ProductSalesCalculator,
  ProfitCalculator,
  RevPashCalculator,
  TotalRevenueCalculator
} from './models/calculators';
import * as KPITypes from './constants';

export const calculateTotalRevenueKPI = async ({ commit, getters: { kpiStorage, predictionPeriodList } }, { pointOfSaleGuid, isManaged }) => {
  if (kpiStorage(KPITypes.TOTAL_REVENUE)(`${pointOfSaleGuid}-${isManaged}`)?.default) {
    const pastPeriods = predictionPeriodList.filter((period) => new Date(period.endDate) < new Date());
    if (pastPeriods.length > 0) {
      const period1 = pastPeriods[0];
      let period2;
      if (pastPeriods.length > 1) {
        // eslint-disable-next-line prefer-destructuring
        period2 = pastPeriods[1];
      } else {
        period2 = null;
      }
      const calculator = new TotalRevenueCalculator(pointOfSaleGuid, period1, period2, isManaged);
      try {
        const model = await calculator.calculateKPI();
        commit(MutationTypes.STORE_KPI, model);
      } catch (err) {
        sentryLogException(err, 'There was an error loading Revenue KPI');
      }
    }
  }
};

export const calculateAverageTicketKPI = async ({ commit, getters: { kpiStorage, predictionPeriodList } }, { pointOfSaleGuid, isManaged }) => {
  if (kpiStorage(KPITypes.AVERAGE_TICKET)(`${pointOfSaleGuid}-${isManaged}`)?.default) {
    const pastPeriods = predictionPeriodList.filter((period) => new Date(period.endDate) < new Date());
    if (pastPeriods.length > 0) {
      const period1 = pastPeriods[0];
      let period2;
      if (pastPeriods.length > 1) {
        // eslint-disable-next-line prefer-destructuring
        period2 = pastPeriods[1];
      } else {
        period2 = null;
      }
      const calculator = new AverageTicketCalculator(pointOfSaleGuid, period1, period2, isManaged);
      try {
        const model = await calculator.calculateKPI();
        commit(MutationTypes.STORE_KPI, model);
      } catch (err) {
        sentryLogException(err, 'There was an error loading Average Ticket KPI');
      }
    }
  }
};

export const calculateRevPashKpi = async ({ commit, getters: { kpiStorage, predictionPeriodList } }, { pointOfSaleGuid, isManaged }) => {
  if (kpiStorage(KPITypes.REV_PASH)(`${pointOfSaleGuid}-${isManaged}`)?.default) {
    const pastPeriods = predictionPeriodList.filter((period) => new Date(period.endDate) < new Date());
    if (pastPeriods.length > 0) {
      const period1 = pastPeriods[0];
      let period2;
      if (pastPeriods.length > 1) {
        // eslint-disable-next-line prefer-destructuring
        period2 = pastPeriods[1];
      } else {
        period2 = null;
      }

      const calculator = new RevPashCalculator(pointOfSaleGuid, period1, period2, isManaged);
      try {
        const model = await calculator.calculateKPI();
        commit(MutationTypes.STORE_KPI, model);
      } catch (err) {
        sentryLogException(err, 'There was an error loading RevPash KPI');
      }
    }
  }
};

export const calculatePosMarginKPI = async ({ commit, getters: { kpiStorage, predictionPeriodList } }, { pointOfSaleGuid, isManaged }) => {
  if (kpiStorage(KPITypes.MARGIN)(`${pointOfSaleGuid}-${isManaged}`)?.default) {
    const pastPeriods = predictionPeriodList.filter((period) => new Date(period.endDate) < new Date());
    if (pastPeriods.length > 0) {
      const period1 = pastPeriods[0];
      let period2;
      if (pastPeriods.length > 1) {
        period2 = pastPeriods[1];
      } else {
        period2 = null;
      }
      const calculator = new MarginCalculator(pointOfSaleGuid, period1, period2, isManaged);
      try {
        const model = await calculator.calculateKPI();
        commit(MutationTypes.STORE_KPI, model);
      } catch (err) {
        sentryLogException(err, 'There was an error loading Margin KPI');
      }
    }
  }
};

export const calculateOccupationKPI = async ({ commit, getters: { kpiStorage, predictionPeriodList } }, { pointOfSaleGuid, isManaged }) => {
  if (kpiStorage(KPITypes.OCCUPATION)(`${pointOfSaleGuid}-${isManaged}`)?.default) {
    const pastPeriods = predictionPeriodList.filter((period) => new Date(period.endDate) < new Date());
    if (pastPeriods.length > 0) {
      const period1 = pastPeriods[0];
      let period2;
      if (pastPeriods.length > 1) {
        period2 = pastPeriods[1];
      } else {
        period2 = null;
      }
      const calculator = new OccupationCalculator(pointOfSaleGuid, period1, period2, isManaged);
      try {
        const model = await calculator.calculateKPI();
        commit(MutationTypes.STORE_KPI, model);
      } catch (err) {
        sentryLogException(err, 'There was an error loading Occupation KPI');
      }
    }
  }
};

export const calculateAverageDinerTimeKPI = async ({ commit, getters: { kpiStorage, predictionPeriodList } }, { pointOfSaleGuid, isManaged }) => {
  if (kpiStorage(KPITypes.AVERAGE_DINER_TIME)(`${pointOfSaleGuid}-${isManaged}`)?.default) {
    const pastPeriods = predictionPeriodList.filter((period) => new Date(period.endDate) < new Date());
    if (pastPeriods.length > 0) {
      const period1 = pastPeriods[0];
      let period2;
      if (pastPeriods.length > 1) {
        period2 = pastPeriods[1];
      } else {
        period2 = null;
      }
      const calculator = new AverageDinerTimeCalculator(pointOfSaleGuid, period1, period2, isManaged);
      try {
        const model = await calculator.calculateKPI();
        commit(MutationTypes.STORE_KPI, model);
      } catch (err) {
        sentryLogException(err, 'There was an error loading Average Diner Time KPI');
      }
    }
  }
};

export const calculateDinerRevenueKPI = async ({ commit, getters: { kpiStorage, predictionPeriodList } }, { pointOfSaleGuid, isManaged }) => {
  if (kpiStorage(KPITypes.DINER_REVENUE)(`${pointOfSaleGuid}-${isManaged}`)?.default) {
    const pastPeriods = predictionPeriodList.filter((period) => new Date(period.endDate) < new Date());
    if (pastPeriods.length > 0) {
      const period1 = pastPeriods[0];
      let period2;
      if (pastPeriods.length > 1) {
        period2 = pastPeriods[1];
      } else {
        period2 = null;
      }
      const calculator = new DinerRevenueCalculator(pointOfSaleGuid, period1, period2, isManaged);
      try {
        const model = await calculator.calculateKPI();
        commit(MutationTypes.STORE_KPI, model);
      } catch (err) {
        sentryLogException(err, 'There was an error loading Diner Revenue KPI');
      }
    }
  }
};

export const calculateDinerMarginKPI = async ({ commit, getters: { kpiStorage, predictionPeriodList } }, { pointOfSaleGuid, isManaged }) => {
  if (kpiStorage(KPITypes.DINER_MARGIN)(`${pointOfSaleGuid}-${isManaged}`)?.default) {
    const pastPeriods = predictionPeriodList.filter((period) => new Date(period.endDate) < new Date());
    if (pastPeriods.length > 0) {
      const period1 = pastPeriods[0];
      let period2;
      if (pastPeriods.length > 1) {
        period2 = pastPeriods[1];
      } else {
        period2 = null;
      }
      const calculator = new DinerMarginCalculator(pointOfSaleGuid, period1, period2, isManaged);
      try {
        const model = await calculator.calculateKPI();
        commit(MutationTypes.STORE_KPI, model);
      } catch (err) {
        sentryLogException(err, 'There was an error loading Diner Margin KPI');
      }
    }
  }
};

export const calculateProductSales = async ({ commit, getters: { kpiStorage, predictionPeriodList } }, { pointOfSaleGuid, isManaged, extraResults }) => {
  if (kpiStorage(KPITypes.PRODUCT_SALES)(`${pointOfSaleGuid}-${isManaged}`)?.default || extraResults !== 0) {
    const pastPeriods = predictionPeriodList.filter((period) => new Date(period.endDate) < new Date());
    if (pastPeriods.length > 0) {
      const period1 = pastPeriods[0];
      const period2 = null;
      const calculator = new ProductSalesCalculator(pointOfSaleGuid, period1, period2, isManaged, extraResults);
      try {
        const model = await calculator.calculateKPI();
        if (!kpiStorage(KPITypes.PRODUCT_SALES)(`${pointOfSaleGuid}-${isManaged}`)?.default) commit(MutationTypes.UPDATE_KPI, model);
        else commit(MutationTypes.STORE_KPI, model);
      } catch (err) {
        sentryLogException(err, 'There was an error loading Product Sales KPI');
      }
    }
  }
};

export const calculateProfitKPI = async ({ commit, getters: { kpiStorage, predictionPeriodList } }, { pointOfSaleGuid, isManaged }) => {
  if (kpiStorage(KPITypes.PERCENTAGE_PROFIT)(`${pointOfSaleGuid}-true`)?.default) {
    const pastPeriods = predictionPeriodList.filter((period) => new Date(period.endDate) < new Date());
    if (pastPeriods.length > 0) {
      const period1 = pastPeriods[0];
      let period2;
      if (pastPeriods.length > 1) {
        period2 = pastPeriods[1];
      } else {
        period2 = null;
      }
      const calculator = new ProfitCalculator(pointOfSaleGuid, period1, period2, isManaged);
      try {
        const model = await calculator.calculateKPI();
        commit(MutationTypes.STORE_KPI, model);
      } catch (err) {
        sentryLogException(err, 'There was an error loading Profit KPI');
      }
    }
  }
};
